import { memo } from "react";
import { Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Copy = ({
  id = "btn-copy",
  title = "button.copy_to_clipboard",
  icon = <CopyOutlined />,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Button
      className="bg-green1 border-green1 hover:opacity-70"
      type="primary"
      icon={icon}
      {...props}
    >
      {title ? title : t(title)}
    </Button>
  );
};

export default memo(Copy);
